import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100px;
  height: 56px;
  background: #f0f2f6;
  border: 1px solid #dee2ea;
  border-radius: 2px;

  color: #c2c6c9;
  font-size: 16px;
`;

const DefaultImage = () => (
  <ImageWrapper className="default-image">
    <FontAwesomeIcon icon={faImage} />
  </ImageWrapper>
);

export default DefaultImage;
